import { useEffect, useState } from "react";
import { InteractionManager } from "react-native";

/**
 * Returns `true` once all pending interactions (navigation transitions, animations)
 * have completed.  Use this to defer heavy work (network fetches, large renders)
 * until the JS thread is free after a `router.replace()` / `router.push()`.
 */
export const useInteractionReady = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const handle = InteractionManager.runAfterInteractions(() => {
      setReady(true);
    });
    return () => handle.cancel();
  }, []);

  return ready;
};
